import { Injectable } from "@angular/core";

@Injectable({
  providedIn: "root",
})
export class EditStateComponent {
  private isEdit: boolean = false;

  // Sæt redigeringstilstanden
  setEditMode(editMode: boolean): void {
    this.isEdit = editMode;
  }

  // Hent redigeringstilstanden
  getEditMode(): boolean {
    return this.isEdit;
  }
}
